<template>
    <div>
        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-lg-7 text-center">
                            <h1 style="color: white">Tin tức khuyến mãi</h1>
                            <p class="lead text-white mt-4 mb-5">Octa là nhà phân phối hàng đầu cung cấp các sản phẩm và dịch vụ viễn thông của tất cả các đơn vị viễn thông trên toàn quốc.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="container pt-lg-md">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <card type="secondary" shadow
                            header-classes="bg-white pb-5"
                            body-classes="px-lg-5 py-lg-5"
                            class="border-0">
                            <template>
                                <div class="text-muted text-center mb-3">
                                    <small>Sign in with</small>
                                </div>
                                <div class="btn-wrapper text-center">
                                    <base-button type="neutral">
                                        <img slot="icon" src="img/icons/common/github.svg">
                                        Github
                                    </base-button>

                                    <base-button type="neutral">
                                        <img slot="icon" src="img/icons/common/google.svg">
                                        Google
                                    </base-button>
                                </div>
                            </template>
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small>Or sign in with credentials</small>
                                </div>
                                <form role="form">
                                    <base-input alternative
                                                class="mb-3"
                                                placeholder="Email"
                                                addon-left-icon="ni ni-email-83">
                                    </base-input>
                                    <base-input alternative
                                                type="password"
                                                placeholder="Password"
                                                addon-left-icon="ni ni-lock-circle-open">
                                    </base-input>
                                    <base-checkbox>
                                        Remember me
                                    </base-checkbox>
                                    <div class="text-center">
                                        <base-button type="primary" class="my-4">Sign In</base-button>
                                    </div>
                                </form>
                            </template>
                        </card>
                        <div class="row mt-3">
                            <div class="col-6">
                                <a href="#" class="text-light">
                                    <small>Forgot password?</small>
                                </a>
                            </div>
                            <div class="col-6 text-right">
                                <a href="#" class="text-light">
                                    <small>Create new account</small>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div> -->
            
        </section>
        <section class="section section-lg pt-lg-0 mt--30">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4 mgb--3rem" v-for="(khuyenmai, index) in tintuckhuyenmai" :key="index">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <!-- <img v-for="(img, index) in tintuckhuyenmai" :key="index" v-bind:src="img.Image" v-if="img.Image == khuyenmai.Image" class="img-tom-tat"> -->
                                    <img v-bind:src="khuyenmai.Image" v-if="khuyenmai.Image" class="img-tom-tat">
                                    <h6 class="text-primary text-uppercase description mt-3">{{khuyenmai.MessageTitle}}</h6>
                                   
                                    <p><span v-html="khuyenmai.MessageContent"></span></p>
                                    <!-- <base-button tag="a" href="#" type="success" class="mt-4" @click="ChiTiet(khuyenmai.postid)">
                                        Chi tiết
                                    </base-button> -->
                                    <!-- <router-link to="/khuyen-mai-{{khuyenmai.postid}}" class="dropdown-item">{{khuyenmai.tieude}}</router-link> -->
                                    <router-link :to="{ name: 'ChiTiet', params: { Pid:khuyenmai.MessageID }}" class="button_details">Chi tiết</router-link>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import TitleSlider from "./components/TitleSlider";
import Badge from "../components/Badge";
import tintuckhuyenmai from "../assets/data/tin-tuc-khuyen-mai.json";
//import HuongDanSuDung from "vue-faq-accordion";
// import axios from 'axios';
export default {
    name: "components",
    components: {
      TitleSlider,
      Badge
    },
    methods: {
        ChiTiet(postid){
            this.$router.push({name: 'ChiTiet', params:{Pid:MessageID}});
            console.log("run");
        },
       // parseJson: () =>{
           // return tintuckhuyenmai = JSON.parse(tintuckhuyenmai);
        //}
    },
    data() {
        return {
            tintuckhuyenmai
        };
    },
    mounted () {
    //   console.log(process.env);
    //     axios.get('api/api/info/khuyen-mai')
    //   .then(response => {
    //       this.khuyenmai = response;
    //   })
  },
    beforeMount(){

    },
    computed: {
        example: {
            cache: false,
            get: function () {
                return Date.now() + this.msg
            }
        }
    }
};
</script>
<style scoped>
    .mgb--3rem{
        margin-bottom: 3rem
    }
    .tom-tat-tin-tuc{
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        height: calc(1em * 1.2 * 6.8);
        text-align: justify;
        text-overflow: ellipsis; 
    }
    .img-tom-tat{
        width: 265px;
        height: 155px;
        display: flex;
        margin: 0 auto;
        object-fit: cover;
        object-position: center;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        margin-bottom: 30px;
    }
    .button_details{
        padding: 12px 25px;
        border-radius: 5px;
        color: #fff;
        background-color: #13b078;
    }
</style>
